import angular from 'angular';

import { loaderService, reportsDataService, ssDialogService } from 'app/services';
import { alerts, actionIcon, confirmDialog } from 'app/components/global';

import reportPackageConfiguration from './reportPackageConfiguration';
import reportPackageGeneratedPackages from './reportPackageGeneratedPackages';
import editPackageSummaryDialog from '../../dialog.editPackageSummary';
import selectEditTypeDialog from '../../dialog.selectEditType';
import directive from './report-package-summary.directive';
import controller from './report-package-summary.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackageSummary', [
    loaderService,
    reportsDataService,
    ssDialogService,
    alerts,
    actionIcon,
    confirmDialog,
    editPackageSummaryDialog,
    selectEditTypeDialog,
    reportPackageConfiguration,
    reportPackageGeneratedPackages,
  ])
  .directive('prReportPackageSummary', directive)
  .controller('PRReportPackageSummaryController', controller).name;

console.log('app.components.reports.packageReports.reportPackageSummary created');
